import { showSuccess } from '@calendly/alert'
import { useFlag } from '@calendly/feature-check-react'
import { I18n } from '@calendly/i18n'
import { useSelector } from 'react-redux'

import { setOrganization } from 'common'
import { rootApi } from 'root-api'
import { isSmsDeactivatedSelector } from 'selectors/current_organization'

const api = rootApi.injectEndpoints({
  tagTypes: ['WorkflowsSettings'],
  endpoints: (build) => ({
    updateOrganization: build.mutation({
      query: ({ user_access_kind: kind }) => ({
        url: '/api/organization',
        method: 'PUT',
        data: {
          user_access_kind: kind
        }
      }),
      onQueryStarted: async (data, { dispatch, queryFulfilled }) => {
        dispatch(setOrganization({ ...data }))
        await queryFulfilled
        dispatch(showSuccess(I18n.t('publisher.flash.settings_saved')))
      }
    }),
    fetchWorkflowsSettings: build.query({
      query: () => ({
        url: '/api/apps/workflows/organization_settings'
      }),
      providesTags: ['WorkflowsSettings']
    }),
    updateWorkflowsSettings: build.mutation({
      query: ({ workflowsEnabledFor }) => ({
        url: '/api/apps/workflows/organization_settings',
        method: 'PATCH',
        data: { organizationSettings: { workflowsEnabledFor } }
      }),
      invalidatesTags: ['WorkflowsSettings'],
      keepUnusedDataFor: 120,
      extraOptions: {
        onSuccess: (_, { dispatch }) => dispatch(showSuccess(I18n.t('publisher.flash.settings_saved')))
      }
    }),
    fetchInvitationRedirect: build.query({
      query: (params = {}) => ({
        url: '/api/organization/invitations/check',
        params,
        validateStatus: (response) => (['200', '204'].includes(`${response}`))
      })
    })
  })
})

export const useFetchWorkflowsSettingsQuery = (opts = {}) => {
  const workflowsExtractionEnabled = useFlag('raven_workflows_extraction')
  return api.useFetchWorkflowsSettingsQuery(opts, { skip: !workflowsExtractionEnabled })
}

export const useIsSmsDeactivated = () => {
  const { data } = useFetchWorkflowsSettingsQuery()
  const monolithIsSmsDeactivated = useSelector(isSmsDeactivatedSelector)

  return data ? data.resource.smsActivatedFor === 'no_one' : monolithIsSmsDeactivated
}

export const {
  useUpdateOrganizationMutation,
  useFetchInvitationRedirectQuery,
  useUpdateWorkflowsSettingsMutation
} = api
